__turbopack_context__.v({
  "form": "hyJFfG_form",
  "image": "hyJFfG_image",
  "line": "hyJFfG_line",
  "skeleton-lines-layout": "hyJFfG_skeleton-lines-layout",
  "skeleton-loading": "hyJFfG_skeleton-loading",
});
